module.exports = __webpack_public_path__ + "static/media/Waleed-Logo.3d52a157.gif";